<template>
  <div class="splash full-size">
    <div class="center-child">
      <div class="img-logo">
        <img src="@assets/logo2.svg" />
        <div>
          <spinner></spinner>
        </div>
        <div class="loading">Initializing...</div>
      </div>
    </div>
  </div>
</template>

<script>
import spinner from "../components/Spinner.vue";
export default {
  components: {
    spinner
  }
};
</script>
